/** Comparaciones de lift por debajo de este n no se muestran como porcentaje. */
export const MIN_LIFT_GROUP = 30;

export function liftSampleReady(groupA: number, groupB: number): boolean {
    return groupA >= MIN_LIFT_GROUP && groupB >= MIN_LIFT_GROUP;
}

export function formatLiftPp(lift: number | null | undefined, ready: boolean): string {
    if (!ready || lift == null || Number.isNaN(Number(lift))) return 'n insuficiente';
    const n = Number(lift);
    return `${n > 0 ? '+' : ''}${n}`;
}
